import { captureException } from '@sentry/react'
import { showError } from 'utils/snackbar'

// One warning for an outage across all note contexts; a successful fetch starts a new episode.
let reportedFailure = false
export const noteRefreshSucceeded = (): void => {
    reportedFailure = false
}
export const reportNoteRefreshFailure = (error: unknown, operation: 'driver_notes_refetch' | 'load_notes_revision_recovery'): void => {
    if (reportedFailure) return
    reportedFailure = true
    captureException(error, { tags: { operation } })
    showError('Notes could not be refreshed. Please reload the board.')
}
